// Lead vocab + colors. Pipeline statuses restructured (CRM revisions Task 2):
// New → Contacted → Negotiating → Won → Lost. "Verify" is gone as a column;
// "New" carries a Verified toggle (sub-status) instead. "Proposal" → "Negotiating".
export const STAGES = ['New', 'Contacted', 'Negotiating', 'Won', 'Lost'];
export const TIERS = ['Anchor', 'Mid', 'Small'];
export const CATEGORIES = ['Hotel', 'Spa', 'Gym', 'Restaurant', 'Salon', 'Clinic'];

export const STAGE_COLOR = {
  New: '#9b9ba3', Contacted: '#2A6DB5', Negotiating: '#7b3fb8',
  Won: '#2D8C5F', Lost: '#C0392B',
};
export const STAGE_BG = {
  New: '#f0f0f2', Contacted: '#e8f0fb', Negotiating: '#efe6fb',
  Won: '#e6f5ed', Lost: '#fce8e6',
};

// Win-probability per stage for the weighted pipeline value (CRM revisions Task 4).
// (No config-defined probabilities exist yet, so these are the source of truth.)
export const STAGE_PROBABILITY = {
  New: 0.10, Contacted: 0.25, Negotiating: 0.60, Won: 1.0, Lost: 0,
};

// Legacy-stage aliases so pre-revision leads ('Verify'/'Proposal') still render
// in the right column instead of vanishing. Applied on display, not by migration.
export const STAGE_ALIASES = { Verify: 'New', Proposal: 'Negotiating' };
export function normalizeStage(stage) {
  return STAGE_ALIASES[stage] ?? stage;
}
export const CAT_COLOR = {
  Hotel: '#1565C0', Spa: '#7b3fb8', Gym: '#2D8C5F',
  Restaurant: '#E07B39', Salon: '#C0392B', Clinic: '#2A6DB5',
};

// Outreach cadence (drawer "Outreach cadence" row + Log Visit channels).
export const CADENCE_STEPS = ['Email', 'Viber', 'SMS', 'Phone', 'In-person'];
// Log Visit channels = cadence + recurring-service touches.
export const VISIT_CHANNELS = [...CADENCE_STEPS, 'Visit', 'Call'];

// Customer account health (Customer Visits + Won-customer drawer card).
export const HEALTH = ['Healthy', 'At-risk', 'Churned'];
export const HEALTH_COLOR = { Healthy: '#2D8C5F', 'At-risk': '#C9911A', Churned: '#C0392B' };
export const CADENCES = ['Weekly', 'Bi-weekly', 'Monthly'];

// ₱/mo proxy from estimated kg/mo (legacy leads pre-revision). Kept ONLY to
// convert old `estMonthlyKg` records to a peso value (mockup used ₱60/kg).
export const PHP_PER_KG = 60;

// Coverage Day — which weekdays a customer's route serves them (CRM revisions
// Task 3). Multi-select; several days allowed.
export const COVERAGE_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// Monthly peso value of a lead (CRM revisions Task 4). New leads store `leadValue`
// directly; legacy leads only have `estMonthlyKg` → convert so views never break.
export function leadValueOf(lead) {
  if (lead?.leadValue != null && lead.leadValue !== '') return Number(lead.leadValue) || 0;
  return (Number(lead?.estMonthlyKg) || 0) * PHP_PER_KG;
}

// Customer requests / feedback — manager-approval flow (DoR-29, T-U3-005).
// Received → Pending → Approved → Rejected; only manager/owner/HQ set the last two.
export const REQUEST_STATUSES = ['received', 'pending', 'approved', 'rejected'];
export const REQUEST_STATUS_LABEL = {
  received: 'Received', pending: 'Pending', approved: 'Approved', rejected: 'Rejected',
};
export const REQUEST_STATUS_COLOR = {
  received: '#2A6DB5', pending: '#C9911A', approved: '#2D8C5F', rejected: '#C0392B',
};
// The two manager-only decision statuses (an agent cannot set these).
export const REQUEST_DECISION_STATUSES = ['approved', 'rejected'];

// Territory slugs (match seed.mjs / firestore docs).
// DEPRECATED for UI use: the app is now tenant-aware — read territories from the
// active tenant's Firestore docs via `useTerritories()` (context/TerritoriesContext),
// NOT from this constant. Kept only as the seed/default reference for Presto.
export const TERRITORIES = [
  { id: 'q2-se', label: 'Q2 · SE' },
  { id: 'q1-ne', label: 'Q1 · NE' },
  { id: 'q3-sw', label: 'Q3 · SW' },
  { id: 'q4-w', label: 'Q4 · W' },
];

// Map display: hub center + corner→territory mapping for the square quadrants.
export const HUB = [14.568033, 121.013817]; // Chino Roces / Davila hub
export const MAP_QUADRANTS = [
  { corner: 'NE', id: 'q1-ne', label: 'Q1 · NE', color: '#1565C0' },
  { corner: 'SE', id: 'q2-se', label: 'Q2 · SE', color: '#C9911A' },
  { corner: 'SW', id: 'q3-sw', label: 'Q3 · SW', color: '#2D8C5F' },
  { corner: 'NW', id: 'q4-w', label: 'Q4 · W', color: '#7b3fb8' },
];
